import { Component } from '@angular/core';

@Component({
    selector: 'app-permit-analytics',
    templateUrl: './permit-analytics.component.html',
    styleUrls: ['./permit-analytics.component.scss'],
})
export class PermitAnalyticsComponent {}
